import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import {
	CenteredCircle,
	DetailContainer,
	HamburgerContainer,
	Header,
	Main,
	MenuButtonContainer,
	MenuContainer,
	StyledCallIcon,
	StyledIconMenu,
} from '../easyclaim.app.components/index';
import theme from '../easyclaim.app.theme/theme';

import { ScreenComponent } from './ScreenComponent';

interface WithoutPayoutProps {
	onHelp: () => void;
	onMenu: () => void;
	onNext: () => void;
}

interface WithoutPayoutState {
	rating?: number;
}

export class WithoutPayout extends ScreenComponent<WithoutPayoutProps, WithoutPayoutState> {
	constructor(props: WithoutPayoutProps) {
		super(props);

		this.state = {};
	}

	public render() {
		return (
			<div className="main-container">
				<Header>
					<MenuContainer>
						<MenuButtonContainer>
							<button className="button-secondary button-small" onClick={this.props.onHelp}>
								<FormattedMessage id="button.help" />
							</button>
						</MenuButtonContainer>
						<HamburgerContainer onClick={this.props.onMenu}>
							<StyledIconMenu />
						</HamburgerContainer>
					</MenuContainer>
				</Header>
				<Main>
					<h2 className="without-payout-title">
						<FormattedMessage id="withoutPayout.headline" />
					</h2>
					<DetailContainer>
						<CenteredCircle
							size="6rem"
							borderColor={theme.colors.success}
							borderStyle="solid"
							borderWidth="3px"
						>
							<StyledCallIcon />
						</CenteredCircle>
						<Paragraph>
							<FormattedMessage id="withoutPayout.description" />
						</Paragraph>
						<Paragraph>
							<FormattedMessage id="withoutPayout.footer" />
						</Paragraph>
					</DetailContainer>
					<footer>
						<button onClick={this.props.onNext}>
							<FormattedMessage id="button.next" /> »
						</button>
					</footer>
				</Main>
			</div>
		);
	}
}

const Paragraph = styled.p`
	margin-bottom: 1rem;
	hyphens: auto;
`;
